<template>
  <wh-popup
    v-model="myVisible"
    title="权威检测"
    @close="hidePopup"
    @submit="submit"
  >
    <div class="test-report-list">
      <van-swipe-cell v-for="(item,key) in testReportList" :key="key" class="report-list-item-box van-hairline--top-bottom">
        <test-report-list-item class="report-list-item" :item="item" />
        <template #right>
          <template v-if="item.certifyType === 1">
            <van-button class="option" square type="info" native-type="button" disabled text="不可删除" />
          </template>
          <template v-else>
            <van-button class="option" square type="danger" native-type="button" text="删除" @click="deleteItem(item, key)" />
            <van-button class="option" square type="primary" native-type="button" text="编辑" @click="editItem(item,key)" />
          </template>
        </template>
      </van-swipe-cell>
    </div>
    <div style="text-align: center;margin-top: 20px;">
      <van-button native-type="button" type="primary" @click="createItem()">
        添加权威检测
      </van-button>
    </div>
    <test-report-popup
      :visible.sync="popup.testReport.show"
      :form-type="popup.testReport.formType"
      :init-form-data="popup.testReport.initFormData"
      :form-index="popup.testReport.formIndex"
      @submit="setTestReport"
    />
  </wh-popup>
</template>

<script>
import { popup } from '@/utils/mixins/popup'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import TestReportListItem from '@/views/productManage/TraceSource/components/TestReportListItem'
import TestReportPopup from '@/views/productManage/TraceSource/components/TestReportPopup'
export default {
  name: 'TestReportListPopup',
  components: { TestReportPopup, TestReportListItem, WhPopup },
  mixins: [popup],
  props: {
    testReportList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      popup: {
        testReport: {
          show: false,
          initFormData: {},
          formType: 'create',
          formIndex: undefined
        }
      }
    }
  },
  methods: {
    isSelected(item) {
      if (item.certifyType === 1) {
        return true
      }
    },
    submit() {
      this.hidePopup()
      this.$emit('change', this.testReportList)
    },
    createItem() {
      this.popup.testReport.formIndex = undefined
      this.popup.testReport.show = true
    },
    editItem(item, index) {
      this.popup.testReport.formIndex = index
      this.popup.testReport.formType = 'edit'
      this.popup.testReport.initFormData = { ...item }
      this.popup.testReport.show = true
    },
    deleteItem({ reportName }, index) {
      this.$dialog.confirm({
        message: `确认删除"${reportName}"?`
      }).then(() => {
        this.testReportList.splice(index, 1)
      }).catch(() => {})
    },
    setTestReport(data, index) {
      if (this.popup.testReport.formType === 'create') {
        this.testReportList.push(data)
      } else {
        this.testReportList.splice(index, 1, data)
      }
    }
  }
}
</script>

<style lang='less' scoped>
.test-report-list {
  /*margin-top: 20px;*/
}
.report-list-item-box {
  position: relative;
  margin: 10px;
  /*box-shadow: 0 0 10px 0 #ccc;*/
  .report-list-item {
    padding: 10px 0;
  }
  .selected-icon {
    position: absolute;
    top: -5px;
    right: -5px;
    color: @primary-color;
    font-size: 30px;
  }
  .option {
    height: 100%;

  }
}
</style>
